import axios from 'axios';
import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import toast, { Toaster } from 'react-hot-toast';
import { getToken } from '../../../utils/auth';


const Leads = () => {
  const { t, i18n } = useTranslation();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    organizationName: '',
    organizationType: 'corporation',
    contactPerson: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.phone || !formData.organizationName) {
      toast.error("Please fill in all required fields.");
      return;
    }
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/lead`,
        {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          organizationName: formData.organizationName,
          organizationType: formData.organizationType,
          contactPerson: formData.contactPerson,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
          },
        }
      );
      setFormData({
        name: '',
        email: '',
        phone: '',
        organizationName: '',
        organizationType: 'corporation',
        contactPerson: '',
      });
      toast.success(response?.data?.message || "Form submitted successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to submit form");
      console.error("Failed to submit form:", error);
    }
  };

  return (
    <Container className='p-2'>
<Toaster position="top-right" reverseOrder={false}/>
<Row>
        <Col lg="12">
          <Card>
            <Card.Header className="card-header d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">{t('leads_title')}</h4>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="acc-edit">
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="form-group">
                    <Form.Label className='required-label'>{t('name_label')}</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder={t('name_placeholder')}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="form-group">
                    <Form.Label className='required-label'>{t('email_label')}</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder={t('email_placeholder')}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="form-group">
                    <Form.Label className='required-label'>{t('phone_label')}</Form.Label>
                    <Form.Control
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder={t('phone_placeholder')}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="form-group">
                    <Form.Label className='required-label'>{t('organization_name_label')}</Form.Label>
                    <Form.Control
                      type="text"
                      name="organizationName"
                      value={formData.organizationName}
                      onChange={handleChange}
                      placeholder={t('organization_name_placeholder')}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="form-group">
                    <Form.Label>{t('organization_type_label')}</Form.Label>
                    <Form.Select
                      name="organizationType"
                      value={formData.organizationType}
                      onChange={handleChange}
                    >
                      <option value="corporation">{t('organization_type_corporation')}</option>
                      <option value="nonprofit">{t('organization_type_nonprofit')}</option>
                      <option value="startup">{t('organization_type_startup')}</option>
                      <option value="small business">{t('organization_type_small_business')}</option>
                      <option value="government">{t('organization_type_government')}</option>
                      <option value="other">{t('other')}</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="form-group">
                    <Form.Label>{t('contact_person_label')}</Form.Label>
                    <Form.Control
                      type="text"
                      name="contactPerson"
                      value={formData.contactPerson}
                      onChange={handleChange}
                      placeholder={t('contact_person_placeholder')}
                    />
                  </Form.Group>
                  <Button type="submit" className="btn btn-primary mt-1">
                    {t('submit_button')}
                  </Button>
                </Form>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Leads;
